module.exports = __webpack_public_path__ + "img/304.62e31c29.png";